module.exports = __webpack_public_path__ + "static/media/Gorou.33b7b5d2.png";